import type {
  CandidateResumeAppliedFilters,
  CandidateResumeFilterFormValues,
} from '../types';

export const getCandidateResumeAppliedFilters = (
  values: CandidateResumeFilterFormValues
): CandidateResumeAppliedFilters => ({
  desiredJob: values.desiredJob,
  employmentTypeId: values.employmentTypeId
    ? Number(values.employmentTypeId)
    : null,
  scheduleWorkId: values.scheduleWorkId ? Number(values.scheduleWorkId) : null,
  isActive: values.isActive === null ? null : values.isActive === 'true',
});

export const hasCandidateResumeAppliedFilters = (
  filters: CandidateResumeAppliedFilters
) =>
  Boolean(
    filters.desiredJob.trim() ||
    filters.employmentTypeId !== null ||
    filters.scheduleWorkId !== null ||
    filters.isActive !== null
  );
